<template>
  <base-display-widget :iteminfo="iteminfo" v-bind="$attrs" v-on="$listeners"
                       class="p-h-8 p-v-10 bg-white "
  >

    <Input v-for="(item,index) in iteminfo.config.datalist"
           class="m-t-10"
           :key="index"
           :placeholder="item.name"
           v-if="item.isShow===1"
    />

    <div class="w-full m-t-10 flex j-center">
      <div :style="{backgroundColor:iteminfo.config.btBgColor,color:iteminfo.config.btTextColor}"
           class="w-100 height-35 flex-column b-radius-5">{{ iteminfo.config.btText }}</div>
    </div>
  </base-display-widget>
</template>

<script>
import BaseDisplayWidget from '../base/BaseDisplayWidget'

export default {
  name: 'PersonalInfoDisplayWidget',
  components: {BaseDisplayWidget},
  props: {
    iteminfo: Object
  },

  data () {
    return {}
  },
  computed: {
    getshowDataList () {
      return this.iteminfo.config.datalist
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      console.log(this.iteminfo.config.datalist)
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
